module.exports = __webpack_public_path__ + "img/08.a60aaac4.png";